export default function Elipsis() {
  return (
    <svg viewBox="64 64 896 896" focusable="false" data-icon="ellipsis" fill="currentColor" aria-hidden="true">
      <path d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" />
    </svg>
  );
}
